import { mapGetters } from 'vuex';

export default {
    name: 'agentTransaction',
    inject: ['$eventBus'],
    props: {
        transactions: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            showMore: false,
        }
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        getTransactions() {
            return this.showMore ? this.transactions : this.transactions.slice(0,5)
        }
    },
    methods: {
        toggle() {
            this.showMore = !this.showMore
            if(!this.showMore) {
                this.$refs.summary.scrollIntoView({behavior: 'smooth'})
            }
        }
    }
};